import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';

export interface IFooterStyles {
  root?: IStyle;
}

export const footerStylesDefault = (theme: IH2OTheme): IFooterStyles => ({
  root: {
    backgroundColor: theme.semanticColors?.footerBackground,
    color: theme.palette?.textOverPrimary,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '10px 0',
    div: {
      textAlign: 'center',
      lineHeight: 20,
    },
  },
});
